import React from 'react';

// используется в ExamList и др. чтобы вывести сообщение, что есть непросмотренные экзамены. 

export default function Modal({ title, children, onClose, onConfirm, cancelText = 'Cancel', confirmText = 'OK', hideCancel = false, }) {

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={headerStyle}>
          <h2 style={titleStyle}>{title}</h2>
          <button style={closeButtonStyle} onClick={onClose}>×</button>
        </div>
        <div style={bodyStyle}>{children}</div>
        <div style={footerStyle}>
          <button
            style={{ ...buttonStyle, background: '#667eea', color: 'white' }}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
          {!hideCancel && (
            <button
              style={{ ...buttonStyle, background: '#eee', color: '#333' }}
              onClick={onClose}
            >
              Cancel
            </button>
          )}
        </div>
      </div>
    </div>
  );
}


// --- Стили:

const overlayStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000
};

const modalStyle = {
  background: 'white',
  borderRadius: '12px',
  width: '90%',
  maxWidth: '600px',
  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
  overflow: 'hidden'
};

const headerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '20px',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  color: 'white',
  borderRadius: '12px 12px 0 0'
};

const titleStyle = {
  margin: 0,
  fontSize: '22px'
};

const closeButtonStyle = {
  background: 'none',
  border: 'none',
  fontSize: '24px',
  color: 'white',
  cursor: 'pointer',
  width: '30px',
  height: '30px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'background-color 0.2s'
};

const bodyStyle = {
  padding: '20px',
  fontSize: '16px',
  color: '#333'
};

const footerStyle = {
  padding: '20px',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '10px',
  borderTop: '1px solid #eee'
};

const buttonStyle = {
  padding: '10px 20px',
  borderRadius: '8px',
  fontSize: '16px',
  border: 'none',
  cursor: 'pointer',
  transition: 'background-color 0.2s'
};
